import dayjs from 'dayjs';
import { IOrganisation } from 'app/shared/model/organisation.model';
import { IEmployee } from 'app/shared/model/employee.model';
import { ICustomer } from 'app/shared/model/customer.model';

export interface ISupplier {
  id?: number;
  name?: string | null;
  origin?: string | null;
  accessToken?: string | null;
  logoURL?: string | null;
  description?: string | null;
  status?: boolean | null;
  createDate?: dayjs.Dayjs | null;
  updateDate?: dayjs.Dayjs | null;
  organisation?: IOrganisation | null;
  supplierAdmin?: IEmployee | null;
  customers?: ICustomer[] | null;
}

export const defaultValue: Readonly<ISupplier> = {
  status: false,
};
